import { getGlobalSettings } from 'app/appState';
import { WarehouseForBooking } from 'entities/Warehouse';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { getLoggedUserData, UserAccountType } from 'entities/User';
import { roundNumber } from 'shared/utils/helpers/roundNumber';

export const useGetMinBoxPriceAmount = (warehouse: Nullable<WarehouseForBooking>): Nullable<number> => {
  if (!warehouse) {
    return null;
  }

  const globalSettings = useAppSelector(getGlobalSettings);
  const loggedUser = useAppSelector(getLoggedUserData);

  if (!globalSettings?.showPriceWithVat) {
    return roundNumber(warehouse.minPrice);
  }

  if (!loggedUser || loggedUser.accountType === UserAccountType.PERSONAL) {
    return roundNumber(warehouse.minPriceWithPersonalVat);
  }

  if (loggedUser.accountType === UserAccountType.BUSINESS) {
    return roundNumber(warehouse.minPriceWithBusinessVat);
  }

  return warehouse.minPrice;
};
